import { CATEGORIES_CONFIG } from "./constants";

export const getRelateServicesFromConstants = (type: "nfb" | "psy" | "reports" | "others") => {
    return CATEGORIES_CONFIG[type].services.map((s) => s.id);
};

